import React, { Component } from "react";
import { connect } from "react-redux";

import {
  ModalContainer,
  KeyboardView,
  Wrapper,
  Row,
  Spin,
  Copy,
  Bold,
  Title,
  LineBreak,
  Button,
  Icon,
  Card,
  Input
} from "app/NativeComponents/common";
import { Header, PillButton } from "app/NativeComponents/snippets";

import {
  toggleDemoPage,
  setDemoPage,
  getDemos,
  updateDemo,
  renderDate,
  openUrl
} from "app/NativeActions";

import moment from "moment";

class DemoSignupModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected_occurance: null,
      user: {
        firstname: props.user ? props.user.firstname : "",
        lastname: props.user ? props.user.lastname : "",
        email: props.user ? props.user.email : "",
        phone: props.user ? props.user.phone : ""
      }
    };
  }

  componentDidMount() {
    const { demo_page } = this.props;
    if (demo_page) {
      this.getData(demo_page.webinar_id);
    }
  }
  componentDidUpdate(prevProps) {
    if (this.props.demo_page && this.props.demo_page !== prevProps.demo_page) {
      this.getData(this.props.demo_page.webinar_id);
    } else if (this.props.user && this.props.user !== prevProps.user) {
      this.setState({
        user: {
          firstname: this.props.user.firstname,
          lastname: this.props.user.lastname,
          email: this.props.user.email,
          phone: this.props.user.phone
        }
      });
    }
  }

  getData(webinar_id) {
    this.props.getDemos({
      type: "get_zoom_webinar",
      webinar_id: webinar_id
    });
  }

  selectOccurance(selected_occurance) {
    this.setState({
      selected_occurance
    });
  }

  editUserField({ prop, value }) {
    this.setState({
      user: {
        ...this.state.user,
        [prop]: value
      }
    });
  }

  checkIfCanSubmit() {
    const { selected_occurance, user } = this.state;

    if (selected_occurance) {
      if (
        this.props.user ||
        (!!user.firstname && !!user.lastname && !!user.email && !!user.phone)
      ) {
        return true;
      }
    }

    return false;
  }
  registerForWebinar() {
    const { user, selected_occurance } = this.state;
    const { demo_page } = this.props;
    if (this.checkIfCanSubmit()) {
      this.props.updateDemo({
        type: "register_zoom",
        firstname: user.firstname,
        lastname: user.lastname,
        user_id: this.props.user ? this.props.user.id : 0,
        email: user.email,
        phone: user.phone,
        webinar_id: demo_page.webinar_id,
        occurrence_id: selected_occurance.occurrence_id,
        onSuccess: () => {
          this.props.toggleDemoPage(false);
        }
      });
    }
  }

  renderUserFields() {
    const { user } = this.state;
    if (!this.props.user) {
      return (
        <Wrapper>
          <Wrapper style={{ paddingTop: 10, paddingBottom: 10 }}>
            <Copy>
              <Bold>Enter your information:</Bold>
            </Copy>
          </Wrapper>
          <Row>
            <Card style={{ flex: 1 }}>
              <Input
                ref="firstname"
                name="firstname"
                returnKeyType="done"
                blurOnSubmit={true}
                autoCapitalize="none"
                placeholder="First Name"
                onChange={value =>
                  this.editUserField({ prop: "firstname", value })
                }
                value={user.firstname}
                type="text"
                onSubmitEditing={() => {}}
              />
            </Card>
            <Card style={{ flex: 1 }}>
              <Input
                ref="lastname"
                name="lastname"
                returnKeyType="done"
                blurOnSubmit={true}
                autoCapitalize="none"
                placeholder="Last Name"
                onChange={value =>
                  this.editUserField({ prop: "lastname", value })
                }
                value={user.lastname}
                type="text"
                onSubmitEditing={() => {}}
              />
            </Card>
          </Row>
          <Row>
            <Card style={{ flex: 1 }}>
              <Input
                ref="phone"
                name="phone"
                mask_type={"cel-phone"}
                returnKeyType="done"
                blurOnSubmit={true}
                autoCapitalize="none"
                keyboardType="numeric"
                placeholder="Phone Number"
                onChange={value => this.editUserField({ prop: "phone", value })}
                value={user.phone}
                type="text"
                mask={"(999) 999-9999"}
                onSubmitEditing={() => {}}
              />
            </Card>
            <Card style={{ flex: 1 }}>
              <Input
                ref="email"
                name="email"
                returnKeyType="done"
                blurOnSubmit={true}
                autoCapitalize="none"
                keyboardType="email-address"
                placeholder="Email Address"
                onChange={value => this.editUserField({ prop: "email", value })}
                onSubmitEditing={() => {}}
                value={user.email}
                type="text"
              />
            </Card>
          </Row>
        </Wrapper>
      );
    }
  }

  render() {
    const {
      show_demo_page,
      demo_page,
      demo_loading,
      demo_error,
      demo,
      colors
    } = this.props;
    const { selected_occurance } = this.state;

    if (show_demo_page && demo_page) {
      return (
        <ModalContainer>
          <Header
            title={demo_page.title}
            leftButtonIcon={"arrow-back"}
            leftButtonAction={() => {
              this.props.toggleDemoPage(false);
            }}
          />
          <KeyboardView>
            {demo_loading ? (
              <Wrapper
                style={{
                  padding: 20,
                  alignItems: "center",
                  justifyContent: "center"
                }}
              >
                <Row>
                  <Spin size="small" />
                  <Copy style={{ marginLeft: 5 }}>Loading...</Copy>
                </Row>
              </Wrapper>
            ) : demo_error ||
              (demo && demo.occurrences && demo.occurrences.length == 0) ? (
              <Wrapper
                style={{
                  padding: 20,
                  alignItems: "center",
                  justifyContent: "center"
                }}
              >
                <Copy style={{ textAlign: "center" }}>
                  This demo no longer exists
                </Copy>
              </Wrapper>
            ) : demo ? (
              <Wrapper style={{ padding: 20 }}>
                <Title style={{ marginBottom: 10 }}>{demo.topic}</Title>
                <Wrapper>
                  {demo.agenda &&
                    demo.agenda.split("\n").map((item, i) => {
                      return (
                        <Copy key={i}>
                          {item}
                          <LineBreak />
                        </Copy>
                      );
                    })}
                </Wrapper>
                <Button
                  style={{
                    paddingTop: 10,
                    justifyContent: "center"
                  }}
                  onPress={() => {
                    openUrl(demo.registration_url);
                  }}
                >
                  <Copy style={{ color: colors.active_color }}>
                    Open Signup Page In New Tab
                  </Copy>
                </Button>

                {this.renderUserFields()}
                <Wrapper style={{ paddingTop: 10, paddingBottom: 10 }}>
                  <Copy>
                    <Bold>Select a time:</Bold>
                  </Copy>
                </Wrapper>
                <Row style={{ flexWrap: "wrap" }}>
                  {demo.occurrences &&
                    demo.occurrences.map((occurrence, i) => {
                      if (occurrence.status == "available") {
                        return (
                          <Button
                            key={i}
                            onPress={() => this.selectOccurance(occurrence)}
                          >
                            <Card
                              style={{
                                padding: 10,
                                borderRadius: 20,
                                marginTop: 0,
                                marginLeft: 0
                              }}
                            >
                              <Row>
                                <Icon
                                  icon={
                                    selected_occurance &&
                                    selected_occurance.occurrence_id ==
                                      occurrence.occurrence_id
                                      ? "radio-button-checked"
                                      : "radio-button-unchecked"
                                  }
                                  size={18}
                                  style={{ marginRight: 5 }}
                                />
                                <Copy>
                                  {moment(occurrence.start_time).format(
                                    "MMM Do h:mm a"
                                  )}
                                </Copy>
                              </Row>
                            </Card>
                          </Button>
                        );
                      }
                      return null;
                    })}
                </Row>
                <Row style={{ marginTop: 10, justifyContent: "flex-end" }}>
                  <PillButton
                    primary={true}
                    disabled={!this.checkIfCanSubmit()}
                    onPress={() => this.registerForWebinar()}
                  >
                    Register
                  </PillButton>
                </Row>
              </Wrapper>
            ) : null}
          </KeyboardView>
        </ModalContainer>
      );
    }
    return null;
  }
}

const mapStateToProps = ({ auth, native, billing, settings, marketing }) => {
  const { token, user } = auth;
  const { device, isMobile, platform } = native;
  const { colors } = settings;
  const { demo_page, show_demo_page } = billing;
  const { demo, demo_loading, demo_error } = marketing;
  return {
    token,
    user,
    device,
    platform,
    colors,
    demo_page,
    show_demo_page,
    demo,
    demo_loading,
    demo_error
  };
};

export default connect(mapStateToProps, {
  toggleDemoPage,
  setDemoPage,
  updateDemo,
  getDemos
})(DemoSignupModal);
